<template>
    <div class="o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap">
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Claim Status
            </div>
            <claim-status></claim-status>
        </div>
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Claim Type
            </div>
            <claim-type></claim-type>
        </div>
        <div class="flex-grid__item--third" v-if="claimType !== 'personal_injury'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Disease or Accident
            </div>
            <disease-or-accident></disease-or-accident>
        </div>
        <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'disease'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Disease Type
            </div>
            <disease-type></disease-type>
        </div>
        <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'accident' || claimType === 'personal_injury'">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Accident Type
            </div>
            <accident-type></accident-type>
        </div>
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Gender
            </div>
            <gender></gender>
        </div>
        <div class="flex-grid__item--third">
            <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons">
                Update Discount Rate
            </div>
            <update-discount-rate></update-discount-rate>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import ClaimStatus from 'pages/discount-rate-comparison/components/form/ClaimStatus.vue';
    import ClaimType from 'pages/discount-rate-comparison/components/form/ClaimType.vue';
    import DiseaseType from 'pages/discount-rate-comparison/components/form/DiseaseType.vue';
    import AccidentType from 'pages/discount-rate-comparison/components/form/AccidentType.vue';
    import DiseaseOrAccident from 'pages/discount-rate-comparison/components/form/DiseaseOrAccident.vue';
    import Gender from 'pages/discount-rate-comparison/components/form/Gender.vue';
    import UpdateDiscountRate from 'pages/discount-rate-comparison/components/form/UpdateDiscountRate.vue';

    export default {
        name: 'book-of-business-search',
        components: {
            ClaimStatus,
            ClaimType,
            DiseaseType,
            AccidentType,
            Gender,
            DiseaseOrAccident,
            UpdateDiscountRate,
        },

        computed: {
            ...mapState('discountRateComparison', {
                getDiscountOrAccident: 'diseaseOrAccident',
                getClaimType: 'claimType',
            }),
            claimType: {
                get() {
                    return this.getClaimType;
                },
            },
            diseaseOrAccident: {
                get() {
                    return this.getDiscountOrAccident;
                },
            },
        },
    }
</script>




// WEBPACK FOOTER //
// BookOfBusinessSearch.vue?464fbcfe